import {Treemap} from '@crema/modules/thirdParty';

export default Treemap;
